// A version's REVIEW answers on the device — pure, no storage. Each question
// answered is a hig_reviewanswer record under the version; a version answered
// before the rows existed may still hold its answers in the old JSON column,
// read for any question with no row (@higgins/m2q-pricing review.ts).
import { answerFromFields, answersFromJson, reviewAnswers, type ReviewAnswers, type ReviewQuestionFromApi } from '@higgins/m2q-pricing';
import type { DeviceRecord } from './device-db';

const answerRecordsOf = (records: readonly DeviceRecord[], versionId: string): DeviceRecord[] =>
  records.filter((r) => r.table === 'reviewanswer' && r.parentId === versionId);

/** The version's answers CRM refused (refused.ts), by question key, with the reason. */
export const refusedAnswersOf = (records: readonly DeviceRecord[], versionId: string): Map<string, string> =>
  new Map(answerRecordsOf(records, versionId).flatMap((r) => (r.refusedReason ? [[String(r.fields.hig_name ?? ''), r.refusedReason] as const] : [])));

/** The version's answers: its rows (by the question each looks up), and the old JSON for questions with none. Throws on JSON in a format this app can't read. */
export function answersOf(version: DeviceRecord, records: readonly DeviceRecord[], questions: readonly ReviewQuestionFromApi[]): ReviewAnswers {
  const rows = answerRecordsOf(records, version.id).map((r) => answerFromFields(r.fields));
  return reviewAnswers(rows, answersFromJson(version.fields.hig_reviewanswers as string | null), questions);
}
